module.exports = __webpack_public_path__ + "img/recyclybac.2d2e1f8b.png";